module.exports = __webpack_public_path__ + "static/media/photo146.af1563b4.jpg";